import script from "./PackageForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageForm.vue?vue&type=script&setup=true&lang=js"

import "./PackageForm.vue?vue&type=style&index=0&id=14d26cc1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14d26cc1"]])

export default __exports__